<template>
    <div :class="white ? 'spinner-white' : 'spinner-blak'"></div>
</template>
  
<script>
export default {
    name: 'ui-loading',
    props: {
        white: Boolean
    }
}
</script>